import {Component, Input, OnInit} from '@angular/core';
import {HttpResponse, HttpErrorResponse, HttpEventType, HttpEvent} from '@angular/common/http';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {FileObject, IFileObject} from '../../shared/model/file-object.model';
import {FileObjectService} from './file-object.service';
// import {MeetingService} from '../meeting/meeting.service';
// import {IMeeting} from '../../shared/model/meeting.model';
import {NgbActiveModal, NgbModal, NgbPanelChangeEvent, NgbRatingConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {AccountService} from '../../singelton/account.service';
import {ToastrService} from 'ngx-toastr';
import {FileUploadService} from './file-upload-service';
import {JhiDataUtils} from 'ng-jhipster';
import {Customer} from "../../shared/model/customer.model";
import {contains} from "html2canvas/dist/types/core/bitwise";

@Component({
  selector: 'app-file-object-update',
  templateUrl: './file-object-update.component.html',
  styles: [`
    .star {
      font-size: 1.5rem;
      color: #b0c4de;
    }

    .filled {
      color: #1e90ff;
    }

    .bad {
      color: #deb0b0;
    }

    .filled.bad {
      color: #ff1e1e;
    }

    .star .fas {
      font-size: 17px !important;
    }
  `]

})

export class FileObjectUpdateComponent implements OnInit {
  // @Input() doctor_id;
  @Input() file_id;
  @Input() title;
  @Input() action;
  @Input() customerId;
  @Input() supplierId;
  @Input() projectId;
  @Input() factorId;
  @Input() contractId;
  @Input() orderId;
  @Input() orderBuyId;
  @Input() salesCycleId;
  @Input() employee;
  @Input() client;
  @Input() token;

  public serverValidationError = false;
  public serverValidationError_msg_title = "";
  public serverValidationError_msg = "";

  isSaving: boolean;
  errorImport: boolean=false;
  fileObjects: IFileObject[] = [];
  showAddParam: boolean;
  editFormFile = this.fb.group({
    id: [],
    title: [],
    itemName: [],
    size: [],
    content: [],
    isImgProfile: [],
    imgProfile: [],
    status: [],
    // doctor: [],
    // patient: [],
    // meeting: [],
    uploaded_by: [],
    contentType: []
  });
  param1: any;
  file: IFileObject = new FileObject();
  file_fileType: any;
  file_size: any;
  file_itemName: any;
  error: any;
  success: any;
  links: any;
  totalItems: any;
  itemsPerPage: any;
  page: any = 0;
  predicate: any;
  previousPage: any;
  reverse: any;
  sortList: any;
  // meetings: IMeeting[] = [];
  readonly = true;
  selected = 0;
  hovered = 0;

  // doctor: IDoctor = new Doctor();
  // meeting: IMeeting;
  profileImg: IFileObject;
  file_doctor: IFileObject;
  form: FormGroup;
  progress = 0;

  beforeChange($event: NgbPanelChangeEvent) {
    if ($event.panelId === 'preventchange-2') {
      $event.preventDefault();
    }

    if ($event.panelId === 'preventchange-3' && $event.nextState === false) {
      $event.preventDefault();
    }
  }

  constructor(protected dataUtils: JhiDataUtils,
              // protected jhiAlertService: JhiAlertService,
              private activeModal: NgbActiveModal,
              protected fileObjectService: FileObjectService,
              protected activatedRoute: ActivatedRoute,
              // public meetingService: MeetingService,
              // private doctorService: DoctorService,
              private modalService: NgbModal,
              private fb: FormBuilder,
              private toastr: ToastrService
    , private spinner: NgxSpinnerService,
              public accountService: AccountService
    ,
              config: NgbRatingConfig,
              public fileUploadService: FileUploadService) {
    this.form = this.fb.group({
      name: [''],
      avatar: [null]
    });
    // customize default values of ratings used by this component tree
    // config.max = 5;
    // config.readonly = true;
  }

  ngOnInit() {
    this.isSaving = false;
    // alert('orderid='+this.orderId);

    // if (this.action === 'approve' && this.file_id) {
    //   this.loadFile(this.file_id);
    // }
  }

  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({
      avatar: file
    });
    this.form.get('avatar').updateValueAndValidity();
  }

  submitUser() {
    this.isSaving = true;

    const fileObject = this.createFormFile();
    if (fileObject.id !== undefined && fileObject.id !== null) {
      this.subscribeToSaveResponseFile(this.fileObjectService.updateProfile(fileObject));
    } else {
      this.subscribeToSaveResponseFile(this.fileObjectService.createProfileImg(fileObject));
    }

  }


  private onSuccessProfile(data, headers) {
    this.fileObjects = data;
    this.totalItems = headers.get('X-Total-Count');
    if (this.fileObjects && this.fileObjects.length > 0) {
      this.profileImg = this.fileObjects[0];
      if (this.profileImg) {
        this.updateFormFile(this.profileImg);
      }
    }
  }

  myFunction(id) {
    const x = document.getElementById(id);

    if (x.style.display === 'none') {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
  }


  showAdd() {
    this.showAddParam = true;
    this.createFormFile();
  }


  open(id) {

    this.fileObjectService.find(id).subscribe((res: HttpResponse<IFileObject>) => {
        this.file = res.body;
        const tabWindowId = window.open('about:blank', '_blank');
        tabWindowId.location.href = this.file.amazonLink;
      },
      (res: HttpErrorResponse) => console.log('______ error ______')
    );
  }

  updateFormFile(fileObject: IFileObject) {
    this.editFormFile.patchValue({
      id: fileObject.id,
      title: fileObject.title,
      content: fileObject.content,
      itemName: fileObject.contentType,
      size: fileObject.contentType,
      isImgProfile: fileObject.isImgProfile,
      imgProfile: fileObject.imgProfile,
      status: fileObject.status,
      uploaded_by: fileObject.uploaded_by,
      contentType: (this.action === 'approve' ? 'Approved' : fileObject.contentType)
    });
  }

  byteSize(field) {
    // return this.dataUtils.byteSize(field);
  }

  openFile(contentType, field) {
    // return this.dataUtils.openFile(contentType, field);
  }

  setFileData(event, field: string, isImage) {
    this.serverValidationError = false;
    const name = <HTMLInputElement>document.getElementById('file_content');


    this.file_itemName = name.files.item(0).name;
    this.file_size = name.files.item(0).size + '';
    this.file_fileType = name.files.item(0).type;

    return new Promise((resolve, reject) => {
      if (event && event.target && event.target.files && event.target.files[0]) {
        const file: File = event.target.files[0];
        if (isImage && !file.type.startsWith('image/')) {
          reject(`File was expected to be an image but was found to be ${file.type}`);
        } else {
          const filedContentType: string = field + 'ContentType';
          this.dataUtils.toBase64(file, base64Data => {
            this.editFormFile.patchValue({
              [field]: base64Data,
              [filedContentType]: file.type
            });
          });
        }
      } else {
        reject(`Base64 data was not set as file could not be extracted from passed parameter: ${event}`);
      }
    }).then(
      // eslint-disable-next-line no-console
      () => console.log('blob added'), // success
      this.onError
    );


    // this.dataUtils.setFileData(event, entity, field, isImage);
  }

  previousState() {
    window.history.back();
  }

  hide() {
    this.showAddParam = false;
    this.createFormFile();
  }

  saveFile() {
    this.serverValidationError = false;

    this.isSaving = true;
    this.progress = Math.round(200 / 200 * 100);
    const fileObject = this.createFormFile();
    if (this.projectId) {
      fileObject.project = this.projectId;
    }
    if (this.factorId) {
      fileObject.factor = this.factorId;
    }
    if (this.contractId) {
      fileObject.contract = this.contractId;
    }
    if (this.orderId) {
      fileObject.order = this.orderId;
      fileObject.customer = this.orderId.customer;
    }
    if (this.orderBuyId) {
      fileObject.orderBuy = this.orderBuyId;
    }
    if (this.salesCycleId) {
      fileObject.salesCycle = this.salesCycleId;
    }
    if (this.customerId || (this.orderId && this.orderId.customer) || this.orderBuyId) {
      if (this.customerId) {
        fileObject.customer = new Customer(this.customerId);
      }
      if ((this.orderId && this.orderId.customer)) {

        fileObject.customer = this.orderId.customer;
      }
      if (fileObject.id !== undefined && fileObject.id !== null) {
        this.subscribeToSaveResponseFile(this.fileObjectService.update(fileObject));
      } else {
        fileObject.isdeleted = false;

        this.subscribeToSaveResponseFile(this.fileObjectService.create(fileObject));
      }
    } else if (this.employee) {
      fileObject.employee = this.employee;
      if (fileObject.id !== undefined && fileObject.id !== null) {
        this.subscribeToSaveResponseFile(this.fileObjectService.updateProfile(fileObject));
      } else {
        fileObject.isdeleted = false;

        this.subscribeToSaveResponseFile(this.fileObjectService.createProfileImg(fileObject));
      }
    } else if (this.client) {
      fileObject.client = this.client;
      if (fileObject.id !== undefined && fileObject.id !== null) {
        this.subscribeToSaveResponseFile(this.fileObjectService.updateProfile(fileObject));
      } else {
        fileObject.isdeleted = false;

        this.subscribeToSaveResponseFile(this.fileObjectService.createProfileImg(fileObject));
      }
    } else {
      if (fileObject.id !== undefined && fileObject.id !== null) {
        this.subscribeToSaveResponseFile(this.fileObjectService.update(fileObject));
      } else {
        fileObject.isdeleted = false;

        this.subscribeToSaveResponseFile(this.fileObjectService.create(fileObject));
      }
    }
  }

  approve() {
    this.isSaving = true;

    this.file_doctor.status = 'Approved';
    this.subscribeToSaveResponseFile(this.fileObjectService.update(this.file_doctor));

  }

  private createFormFile(): IFileObject {
    return {
      ...new FileObject(),
      id: this.editFormFile.get(['id']).value,
      // title: (this.title === 'profileImg' ? 'عکس پروفایل' : this.editFormFile.get(['title']).value),
      title: (this.title === 'profileImg' ? 'عکس پروفایل' : (this.title === 'import_excel' ? 'import_excel' : this.editFormFile.get(['title']).value)),
      uploaded_by: (this.editFormFile.get(['uploaded_by']).value),
      contentType: this.file_fileType,
      itemName: this.file_itemName,
      size: this.file_size,
      // isImgProfile:   false,
      isImgProfile: (this.title === 'profileImg' ? true : false),
      imgProfile: (this.title === 'profileImg' ? true : false),
      // imgProfile: false,
      // doctor: this.doctor,
      status: (this.accountService.hasAnyAuthority(['ROLE_ADMIN']) ? 'Approved' : 'Pending'),
      content: this.editFormFile.get(['content']).value
    };
  }


  protected subscribeToSaveResponseFile(result: Observable<HttpResponse<IFileObject>>) {
    result.subscribe(() => this.onSaveSuccessFile(),
    (res: HttpErrorResponse) => this.onSaveErrorFile(res)
    );

  }

  protected onSaveSuccessFile() {
    this.isSaving = false;
    this.showAddParam = false;
    this.clear();
    if(this.title === 'import_excel') {
      this.toastr.success('بارگذاری اطلاعات فایل با موفقیت انجام شد', '!موفق');
    } else {
      this.toastr.success('.ثبت فایل شما با موفقیت انجام شد', '!موفق');

    }
  }

  clear() {
    this.activeModal.dismiss('save');
  }

// {"headers":{"normalizedNames":{},"lazyUpdate":null},
//   "status":400,
//   "statusText":"Bad Request",
//   "url":"http://localhost:8081/api/files",
//   "ok":false,
//   "name":"HttpErrorResponse",
//   "message":"Http failure response for http://localhost:8081/api/files: 400 Bad Request",
//   "error":{"entityName":"userManagement","errorKey":"emailexists","type":"https://www.jhipster.tech/problem/phone-number-already-used",
//     "title":"شماره 09136450422 قبلاً در سیستم ثبت شده است.!","status":400,"message":"error.emailexists","params":"userManagement"}}
  protected onSaveErrorFile(response) {
    this.isSaving = false;
    if (response.status === 400) {
      this.serverValidationError = true;
      // if(response.error.title !='Bad Request'){
      if (response.error.title.includes('قبلاً در سیستم ثبت شده است')) {
        this.serverValidationError_msg_title = 'شماره تلفن تکراری در این فایل وجود دارد! لطفاً فایل را چک کرده و دوباره تلاش کنید.';
        this.serverValidationError_msg = response.error.title;
        // }
      } else {

        if (response.error.detail.includes('request was larger than')) {
          this.serverValidationError_msg_title = 'حجم فایل نباید بیشتر از 20 مگابایت باشد!';
          this.serverValidationError_msg = 'حجم فایل را چک کنید و دوباره تلاش کنید';
        } else {
          this.serverValidationError_msg_title = 'در بارگذاری فایل خطایی رخ داده است!';
          this.serverValidationError_msg = 'دوباره تلاش کنید';
        }
      }
      // request was larger than
      // Bad Request
    }else if (response.status === 500) {
      this.serverValidationError = true;

      this.serverValidationError_msg_title = 'در بارگذاری فایل خطایی رخ داده است!';
      this.serverValidationError_msg = 'خطا در اتصال به شبکه';

    } else {

      this.errorImport=true;

    }
      // alert(' onsavee errorImport=='+this.errorImport)
    // alert(' onsavee isSaving=='+this.isSaving)
  }

  protected onError(errorMessage: string) {
  }


}
